import { Box, Typography } from '@material-ui/core'
import React, { useEffect, useState } from 'react'
import { Autocomplete } from 'src/components/ui/Autocomplete'
import Button from 'src/components/ui/Button'
import Drawer from 'src/components/ui/Drawer'
import { showNotificationErrorAPI } from 'src/core/helpers/notification'
import {
  cadastrarResponsavelSolicitacaoOrcamento,
  listarResponsaveis
} from 'src/api/solicitacao-orcamento'
import { ResponsavelUsuarioResponse } from 'src/types'
import Swal from 'sweetalert2'

type Props = {
  id: string
  open: boolean
  handleOnClose: (boolean?) => void
}

const COR_SEM_VINCULO_BITRIX = '#C62828'

function DrawerCadastrarDono(props: Props) {
  const [usuarioSelecionado, setUsuarioSelecionado] = useState<
    ResponsavelUsuarioResponse | undefined
  >(undefined)
  const [responsaveis, setResponsaveis] = useState<ResponsavelUsuarioResponse[]>(
    []
  )
  const [loadingResponsaveis, setLoadingResponsaveis] = useState(false)
  const [loadingSalvar, setLoadingSalvar] = useState(false)

  useEffect(() => {
    if (!props.open) {
      setUsuarioSelecionado(undefined)
      return
    }

    setLoadingResponsaveis(true)
    listarResponsaveis()
      .then(response => setResponsaveis(response.data ?? []))
      .catch(showNotificationErrorAPI)
      .finally(() => setLoadingResponsaveis(false))
  }, [props.open])

  function handleOnChange(
    _event: unknown,
    newValue: ResponsavelUsuarioResponse | null
  ) {
    setUsuarioSelecionado(newValue ?? undefined)
  }

  async function handleSalvar() {
    if (!usuarioSelecionado) return

    try {
      setLoadingSalvar(true)
      await cadastrarResponsavelSolicitacaoOrcamento(
        usuarioSelecionado.usuarioId,
        props.id
      )
      setUsuarioSelecionado(undefined)
      Swal.fire({
        icon: 'success',
        title: 'Sucesso!',
        text: 'Responsável cadastrado com sucesso',
        confirmButtonText: 'Ok'
      })
      props.handleOnClose(true)
    } catch (e) {
      showNotificationErrorAPI(e)
      props.handleOnClose()
    } finally {
      setLoadingSalvar(false)
    }
  }

  return (
    <Drawer
      anchor="right"
      open={props.open}
      titulo="Cadastrar Responsável da solicitaçao"
      handleOnClose={() => props.handleOnClose()}
    >
      <Autocomplete
        erro={{}}
        name="responsavel"
        label="Responsável"
        value={usuarioSelecionado ?? null}
        options={responsaveis}
        loading={loadingResponsaveis}
        getOptionLabel={option => option.nome}
        getOptionSelected={(option, value) =>
          option.usuarioId === value.usuarioId
        }
        renderOption={(option: ResponsavelUsuarioResponse) => (
          <Box display="flex" flexDirection="column">
            <Typography
              variant="body2"
              style={{
                color: option.idBitrix ? undefined : COR_SEM_VINCULO_BITRIX
              }}
            >
              {option.nome}
            </Typography>
            {!option.idBitrix && (
              <Typography
                variant="caption"
                style={{ color: COR_SEM_VINCULO_BITRIX, fontWeight: 500 }}
              >
                Sem vínculo com Bitrix
              </Typography>
            )}
          </Box>
        )}
        onChange={handleOnChange}
      />
      <Box mt={3}>
        <Button
          disabled={!usuarioSelecionado || loadingSalvar}
          fullWidth
          onClick={handleSalvar}
          loading={loadingSalvar}
          secondaryLoading
        >
          Salvar
        </Button>
      </Box>
    </Drawer>
  )
}

export default DrawerCadastrarDono
